import { MimeTypeModel } from '../models/MimeTypeModel';
import { DataService } from '../../data.service';

export class MimeTypeController {
    constructor(private dataService: DataService) { }

    async CreateOrUpdate(model: MimeTypeModel): Promise<MimeTypeModel> {
        let response = model;
        if (model && model.Dto) {
            response = await this.dataService.CreateOrUpdateMimeType(model);
            if (response && response.Performed) {
                response.Dto.Id = response.Entity?.Id;
            }
        }
        return response;
    }

    async Get(model: MimeTypeModel): Promise<MimeTypeModel> {
        const response = await this.dataService.GetMimeType(model);
        return response;
    }

}
